import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { setPageName } from '../reducers/pageSlice';
import TabFactory from '../components/tabs/TabFactory';
import { tabSlice } from '../reducers/supervisorDashboard/tabs';

function SupervisorDashboard() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setPageName('Supervisor Dashboard'));
  }, []);

  return <TabFactory slice={tabSlice} />;
}

export default SupervisorDashboard;
